import { render, staticRenderFns } from "./ChatBadge.vue?vue&type=template&id=fd6644da&scoped=true&"
import script from "./ChatBadge.vue?vue&type=script&lang=js&"
export * from "./ChatBadge.vue?vue&type=script&lang=js&"
import style0 from "./ChatBadge.vue?vue&type=style&index=0&id=fd6644da&prod&scoped=true&lang=css&"
import style1 from "./ChatBadge.vue?vue&type=style&index=1&id=fd6644da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6644da",
  null
  
)

export default component.exports